// A null cell reads NA only on rows that explain it (naReason); every other row keeps '-'.
export function getRowText(value: any, unit = '', roundOffRequired = false, naReason?: string) {
    if (typeof value === 'number') {
        if (unit === '%' || roundOffRequired) {
            return parseFloat(value.toFixed(1))?.toLocaleString('en-IN') + unit;
        }
        return parseFloat(value.toFixed(2))?.toLocaleString('en-IN') + unit;
    } else return value ?? (naReason ? 'NA' : '-');
}

// Longest formatted value across all rows/year columns, so the tab's mobile floor fits real figures.
export function getLongestValueCharLength(rows: any[], headers: any[]): number {
    let maxLength = 0;
    rows?.forEach((row) => {
        headers?.forEach((header, index) => {
            if (index === 0) return;
            const length = String(getRowText(row?.[header.key], row?.unit, row?.roundOffRequired)).length;
            if (length > maxLength) maxLength = length;
        });
    });
    return maxLength;
}
